export * from './stat/stat.module';
export * from './page-header/page-header.module';
export * from './contact-table/contact-table.module';
export * from './offer-table/offer-table.module';
export * from './order-table/order-table.module';
export * from './email-dialog/email-dialog.module';

export * from './product-select-dialog/product-select-dialog.module';
export * from './product-select-dialog/product-select-dialog.component';

// export * from './document-table/document-table.module';



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/index.ts